import styled from "@emotion/styled";

export const FilterCountBadgeSlot = styled.span`
  display: grid;
  grid-template-columns: 0fr;
  margin-inline-start: 0;
  overflow: hidden;
  transition: grid-template-columns 150ms ease-out,
    margin-inline-start 150ms ease-out;

  > .badge-content {
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-inline: 0;
    height: 18px;
    font-size: ${({ theme }) => theme.fontSizes.fontSize12};
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.tone.white};
    background-color: ${({ theme }) => theme.colors?.tone.black};
    border-radius: 9px;

    opacity: 0;
    transition: opacity 50ms ease-out;
  }

  &.active {
    grid-template-columns: 1fr;
    margin-inline-start: ${({ theme }) => theme.space.space8};

    transition: grid-template-columns 150ms ease-in,
      margin-inline-start 150ms ease-in;

    > .badge-content {
      min-width: 18px;
      padding-inline: ${({ theme }) => theme.space.space4};
      opacity: 1;
      transition: opacity 150ms ease-in 50ms;
    }
  }
`;
